// ***********************************************************************
// Assembly         : Veriteq.Partner.Web
// Author           : Mike Palmer
// Created          : 06-21-2024
//
// Last Modified By : Mike Palmer
// Last Modified On : 06-21-2024
// ***********************************************************************
// <copyright file="_resizing.js" company="NSA Group Ltd">
//     Copyright (c) NSA Group Ltd. All rights reserved.
// </copyright>
// <summary>
//     JavaScript utility for managing resizing events and dynamically adjusting the 
//     visibility of Veriteq input group elements based on their container's width.
// </summary>
// ***********************************************************************

window.resizing = window.resizing || {};

/**
 * Initializes event listeners for window resizing and DOM content loading,
 * and triggers the resizing logic for Veriteq input groups.
 * This function ensures that the input groups are correctly adjusted upon page load
 * and whenever the window is resized.
 * 
 * @function initialize
 * @memberof window.resizing
 */
window.resizing.initialize = function () {
    window.addEventListener('resize', resizing.veriteq_input_group);
    document.addEventListener('DOMContentLoaded', resizing.veriteq_input_group);
    resizing.veriteq_input_group();
};

/**
 * Handles the resizing logic for Veriteq input groups.
 * This function checks the width of the parent element of each `.veriteq-input-state` element,
 * and adds or removes the `veriteq-input-state__hidden` class based on the parent's width.
 * If the parent element's width is less than 120 pixels, the input state element is hidden.
 * 
 * @function veriteq_input_group
 * @memberof window.resizing
 */
window.resizing.veriteq_input_group = function () {
    const elements = document.querySelectorAll('.veriteq-input-state');
    elements.forEach(child => {
        const parent = child.closest('.veriteq-input-group');
        if (parent && parent.offsetWidth < 120) {
            child.classList.add('veriteq-input-state__hidden');
        } else {
            child.classList.remove('veriteq-input-state__hidden');
        }
    });
};
